import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=d86f36e6&scoped=true&"
import script from "./Phones.vue?vue&type=script&lang=js&"
export * from "./Phones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86f36e6",
  null
  
)

export default component.exports